/**
 * @module navigation
 */
(function FloatSidebar () {
    function floatSidebar () {
        /**
         * // local object availability
         * @type {floatSidebar}
         * @private
         */
        var _this = this;

        /**
         * @type {string}
         */
        this.toggleClassName = 'sub-menu-is-visible';

        /**
         * @type {array}
         */
        this.elementsCollection = [];

        /**
         * @method cacheDom
         *
         *  assign {jQuery|HTMLElement(s)} to {floatSidebar} object
         */
        this.cacheDom = function () {
            this.$currentLanguageElement = $("[data-html-element='current-language']");
            this.$searchIconElement = $("[data-html-element='search']");
            this.$searchFormWrapperElement = $("[data-html-element='search_form-wrapper']");
            this.$floatLanguageMenuElement = $("[data-html-element='float-language-menu']");
            this.$socialIconsWrapperElement = $(".social-icons_wrapper");
            this.$closeOffCanvasElement = $("[data-html-element='close-off-canvas']");
        };

        /**
         * @method bindEvents
         * @returns {undefined}
         */
        this.bindEvents = function () {
            $(_this.elementsCollection).each(function (){
                $(this).on('click', _this.controlCssClass);
            });
            $(_this.$searchFormWrapperElement).on('click', function(){
                _this.$searchIconElement.addClass(_this.toggleClassName);
            });
            $(_this.$floatLanguageMenuElement).on('click', function(){
                _this.$currentLanguageElement.addClass(_this.toggleClassName);
            });
            $(_this.$socialIconsWrapperElement).on('click', function(){
                _this.removeUnclickedElementClass(_this.elementsCollection);
            });
            $(_this.$closeOffCanvasElement).on('click', function(){
                _this.removeUnclickedElementClass(_this.elementsCollection);
            });
        };

        /**
         * @method controlCssClass
         * @returns {undefined}
         */
        this.controlCssClass = function (e) {
            //stop bubbling
            e.stopPropagation();
            var clickedElement = e.target;
            var clickedElementAttribute = $(clickedElement).attr('data-html-element');
            if((clickedElementAttribute == 'current-language' ) || clickedElementAttribute == 'search'){
                _this.removeUnclickedElementClass(_this.elementsCollection, this);
                $(this).toggleClass(_this.toggleClassName);
            } else {
                _this.removeUnclickedElementClass(_this.elementsCollection);
            }

            if(clickedElementAttribute === 'search' && $(this).hasClass(_this.toggleClassName)) {
                $(this).find('input').focus();
            }
        };

        /**
         * @method addElementIntoCollection
         * @returns {undefined}
         */
        this.addElementIntoCollection = function () {
            _this.elementsCollection.push(_this.$currentLanguageElement);
            _this.elementsCollection.push(_this.$searchIconElement);
            _this.elementsCollection.push(_this.$searchFormWrapperElement);
            _this.elementsCollection.push(_this.$floatLanguageMenuElement);
        };

        /**
         * @method removeUnclickedElementClass
         * @returns {undefined}
         */
        this.removeUnclickedElementClass= function (array, currentClickedElement) {
            $(array).each(function (){
                $(this).not(currentClickedElement).removeClass(_this.toggleClassName);
            });
        };

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            _this.cacheDom();
            _this.addElementIntoCollection();
            _this.bindEvents();
        };

        /**
         * initialize call
         */
        _this.init();
    }

    // define the global scope
    if (!window.Juzo) {
        window.Juzo = {};
    }
    window.Juzo.floatSidebar = floatSidebar;
}) ();
$(document).ready(function () {
    window.Juzo.floatSidebar.call(window.Juzo.floatSidebar);
});